import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationAddon } from "Reducers/organization/addons";

export const updateAddonsRequest = (organizationId: string, payload: object) =>
  apiProxyRequest<OrganizationAddon>(
    `/organizations/${organizationId}/addons`,
    "PATCH",
    payload
  );
